import React from 'react';

import { Row, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { customStyles } from '../utils';

import './styles.scoped.css';

// PRST-130 criteria card. Payment Date Range is required (red asterisk); the three
// refinements below it are optional and AND-combined by the proc. PRST-139 removed the
// placeholder descriptors from the two free-text refinements.
export const PaymentRegisterForm = ({
  form,
  setForm,
  handleChange,
  errors,
  AMCCodeOptions = [],
  isLoadingAMCCodes,
}) => (
  <div className="filters-container">
    <div className="filter-row" style={{ marginTop: '30px' }}>
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '180px', marginBottom: 0 }}>
          <div className="required">Payment Date Range</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="FromPaymentDate"
          aria-label="From Payment Date"
          value={form?.FromPaymentDate}
          onChange={handleChange}
          max={form?.ToPaymentDate || undefined}
        />
        <span className="date-divider">to</span>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="ToPaymentDate"
          aria-label="To Payment Date"
          value={form?.ToPaymentDate}
          onChange={handleChange}
          min={form?.FromPaymentDate || undefined}
        />
      </Form.Group>
    </div>
    {errors?.PaymentDateRange && <div className="field-error">{errors.PaymentDateRange}</div>}

    <div className="filter-row refine-message">One or more of the following to refine (not required)</div>

    <div className="filter-row">
      <Form.Group as={Row} controlId="CustomerName" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '180px', marginBottom: 0 }}>Customer Name</Form.Label>
        <Form.Control
          style={{ width: '365px', height: '30px' }}
          as="input"
          type="text"
          name="CustomerName"
          value={form?.CustomerName}
          onChange={handleChange}
        />
      </Form.Group>
    </div>

    <div className="filter-row">
      <Form.Group as={Row} controlId="BillToNumber" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '180px', marginBottom: 0 }}>Bill To Number</Form.Label>
        <Form.Control
          style={{ width: '365px', height: '30px' }}
          as="input"
          type="text"
          inputMode="numeric"
          name="BillToNumber"
          value={form?.BillToNumber}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.BillToNumber && <div className="field-error">{errors.BillToNumber}</div>}

    <div className="filter-row">
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '180px', marginBottom: 0 }}>AMC Code</Form.Label>
        <Select
          isDisabled={isLoadingAMCCodes}
          isMulti
          closeMenuOnSelect={false}
          placeholder="Select one or more AMC codes"
          styles={customStyles('365px')}
          options={AMCCodeOptions}
          value={AMCCodeOptions.filter(option => (form?.AMC ? form.AMC.split(',') : []).includes(option.value))}
          onChange={selectedOptions => {
            setForm({ ...form, AMC: (selectedOptions || []).map(option => option.value).join(',') });
          }}
        />
        <Spinner
          as="span"
          animation="border"
          size="sm"
          aria-hidden="true"
          className="dropdown-spinner"
          hidden={!isLoadingAMCCodes}
        />
      </Form.Group>
    </div>
  </div>
);
